import VideoOperation from './video-operation';

export default VideoOperation;
